import { Box } from 'app/shopify/theme';
import { type ComponentProps } from 'react';

type RowProps = ComponentProps<typeof Box>;

export function Row(props: RowProps) {
  return <Box {...props} flexDirection="row" />;
}
